import React, { useEffect } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import VideoLoader from "./VideoLoader";

interface Level {
  _id: string;
  name: string;
  minPoints: number;
  maxPoints: number;
  discount: number;
  color: string;
  minPointExpiryDays: number;
  maxPointExpiryDays: number;
}

interface LoyaltyBarProps {
  spendAmount?: number | null;
  currentLevel?: Level | null;
  onDiscountChange?: (discount: number) => void;
  levels: Level[];
  loading?: boolean;
}

const LoyaltyBar: React.FC<LoyaltyBarProps> = ({
  spendAmount,
  currentLevel,
  onDiscountChange,
  levels,
  loading = false,
}) => {
  // Report the discount after render — calling the parent's setState during
  // render triggers React's "Cannot update a component while rendering" error.
  useEffect(() => {
    if (currentLevel && onDiscountChange) {
      onDiscountChange(currentLevel.discount);
    }
  }, [currentLevel, onDiscountChange]);

  // Show loader while data is being fetched
  if (loading) {
    return (
      <div className="flex items-center justify-center h-[60px]">
        <VideoLoader size="small" />
      </div>
    );
  }

  // If no levels were fetched, show a message
  if (levels.length === 0) {
    return (
      <div className="text-center text-xs">
        <p>Will Be Available Soon.</p>
      </div>
    );
  }

  // If no currentLevel or spendAmount, don't render anything
  if (!currentLevel || spendAmount == null) {
    return null;
  }

  // Progress is based on spendAmount vs maxPoints of current level
  const progress = Math.min((spendAmount / currentLevel.maxPoints) * 100, 100);

  return (
    <div className="text-xs">
      <ProgressBar
        completed={progress}
        maxCompleted={100}
        customLabel=" "
        bgColor={currentLevel.color}
        height="10px"
        baseBgColor="#e0e0e0"
        width="100%"
      />
      <p className="mt-1 text-start m-0">{currentLevel.name}</p>
    </div>
  );
};

export default LoyaltyBar;